export default __webpack_public_path__ + "static/MojoStar-b2044f11035e35c43979882856060527.svg";